export default "__VITE_ASSET__VNxU9707__"